var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-4 px-4"},[_c(_vm.viewMap[_vm.currentView],{tag:"component",on:{"changeView":_vm.changeView}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }